import {ApplicationConfig, EnvironmentProviders, importProvidersFrom, isDevMode, makeEnvironmentProviders} from '@angular/core';
import {provideRouter} from '@angular/router';

import {routes} from './app.routing';
import {HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withFetch, withInterceptorsFromDi} from '@angular/common/http';

import {DatePipe, registerLocaleData} from '@angular/common';
import localeIT from '@angular/common/locales/it';
import localeFR from '@angular/common/locales/fr';
import localeDE from '@angular/common/locales/de';
import localeEN from '@angular/common/locales/en';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {DialogService} from 'primeng/dynamicdialog';
import {environment} from '../environments/environment';
import {SpinnerServiceConfig} from '@shared-lib';
import {ErrorInterceptor} from './core/http/error.interceptor';
import {TINYMCE_SCRIPT_SRC} from '@tinymce/tinymce-angular';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {providePrimeNG} from 'primeng/config';
import {MaterialPreset} from './styles-preset';
import {HttpRequestInterceptor} from './core/http/http-request.interceptor';
import {provideServiceWorker} from '@angular/service-worker';

registerLocaleData(localeIT);
registerLocaleData(localeFR);
registerLocaleData(localeDE);
registerLocaleData(localeEN);

export function HttpLoaderFactory(http: HttpClient) {
	return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function provideSpinner(config: SpinnerServiceConfig): EnvironmentProviders {
	return makeEnvironmentProviders([
		{provide: SpinnerServiceConfig, useValue: config}
	]);
}

export const appConfig: ApplicationConfig = {
	providers: [
		provideRouter(routes),
		provideHttpClient(withFetch(), withInterceptorsFromDi()),
		provideAnimationsAsync(),
		provideSpinner({
			spinnerText: '',
			bgColor: 'rgba(0, 0, 0, 0.4)',
			size: 'large',
			color: environment.spinnerColor,
			// type: 'square-spin',
			type: 'ball-pulse-sync',
			fullScreen: false,
			zIndex: 99999
		}),
		providePrimeNG({
			theme: {
				preset: MaterialPreset,
				options: {
					darkModeSelector: 'none'
				}
			},
			pt: {
				button: {
					root: 'p-button-outlined' // override (global pass-through) per tutti i pulsanti diventano outlined
					// p-button-plain --> se alla lunga si vede che i colori primary dei clienti a volte non vanno bene... tutti btn PLAIN
				}
			}
		}),
		{provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
		{provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true},
		{provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js'},
		MessageService,
		DialogService,
		ConfirmationService,
		DatePipe,
		importProvidersFrom(
			BrowserAnimationsModule,
			TranslateModule.forRoot({
				loader: {
					provide: TranslateLoader,
					useFactory: HttpLoaderFactory,
					deps: [HttpClient]
				}
			})
		), provideServiceWorker('ngsw-worker.js', {
			enabled: !isDevMode(),
			registrationStrategy: 'registerImmediately'
		})
	]
};
